import React,{useState,useEffect} from "react";
import { getBotListFromLibrary,getBotDeploymentConfigByEnv } from "../apis/bots";
import { getAgentsByEnvironment,createAgent, getAgents } from "../apis/agents";
import { TextInput } from "./GenericReusableComponents/HTMLWrappers";
import { FormDialog } from "./GenericReusableComponents/FormDialog";

export function TestAPI(){
    const[bots,setBots] = useState([]);
    const[agents,setAgents] = useState([])
    const[createAgentResponse,setCreateAgentResponse] = useState([""])
    const[botDeploymentProfile,setBotDeploymentProfile] = useState([]);
    const[showDialog,setShowDialog] = useState(true);
    const[agent,setAgent] = useState({
        name: "Agent1"
    })
    
   
    function getBots(){
        getBotListFromLibrary().then((bots)=>{
            setBots(bots);
        })
    }

    function getAgentsByEnv(){
        getAgentsByEnvironment("DEV").then((agents)=>{
            setAgents(agents);
        })
    }

    function getAgentsByTenantId(){
        getAgents().then((agents)=>{
            setAgents(agents);
        })
    }

    function createNewAgent(){
        let agent = {
            environment: "DEV",
            agentName: "AgentDev1",
            description: "Dev 1",
            category: "America"
        }

        console.log(JSON.stringify(agent))
        createAgent(agent).then( (data) => {
            setCreateAgentResponse(JSON.stringify(data));
        })

    }

    function getDeploymentConfigByEnv(){
        getBotDeploymentConfigByEnv("DEV").then((botAgentLinkList)=>{
            console.log("getBotDeploymentConfigByEnv sucessfull")
            setBotDeploymentProfile(botAgentLinkList);
        })

    }

    function onChangeHandler(e){
        let lagent = {...agent};
        lagent.name = e.target.value;
        setAgent(lagent);
    }

    function getFormElements(){
        return(
            <TextInput tname="Agent Name" 
            tplaceholder = "Enter Agent Name"
            tvalue = {agent.name}
            tHandleOnChange={e => onChangeHandler(e)} />
        )
    }

    function formSubmit(){
        console.log(`Form Submit ${JSON.stringify(agent)}`);

    }
    return (
        <div>
            <button onClick={()=> getBots()}>getBots</button>
                <p>
                <ul>
                    {bots.map(b =>(
                        <li>
                            {JSON.stringify(b)}
                        </li>
                    ))}
                </ul>
                </p>
            <button onClick={()=> getAgentsByTenantId()}>getAgentsByEnv</button>
                <p>
                <ul>
                    {agents.map(a =>(
                        <li>
                            {JSON.stringify(a)}
                        </li>
                    ))}
                </ul>
                </p>

            <button onClick={()=> getAgentsByEnv()}>getAgents</button>
                <p>
                <ul>
                    {agents.map(a =>(
                        <li>
                            {JSON.stringify(a)}
                        </li>
                    ))}
                </ul>
                </p>

            <button onClick={()=> createNewAgent()}>createAgent</button>
                <p>{createAgentResponse}</p>


            <button onClick={()=> getDeploymentConfigByEnv()}>getDeploymentConfigByEnv</button>
                <p>{JSON.stringify(botDeploymentProfile)}</p>

            <button onClick={()=> setShowDialog(true)}>Test Form Dialog</button>
                <FormDialog 
                    showDialog={showDialog} 
                    setShowDialog={setShowDialog} 
                    formHeader="Add Agent" 
                    formElements={getFormElements()} 
                    submitButtonMessage="Add Agent" 
                    onFormSubmit={formSubmit}/>
        </div>
    )
}